export default {
	"0775b92d58a5c7ab6552436c162ba136": "商品详情页_更多优惠券点击",
	"a5a1b35089fae034b3bdf78b9a303e00": "更多优惠券"
}
